import React from 'react';

import ToggleSync from './ToggleSync';

export default function ToggleTrackingCategoriesSync(props) {
    return (
        <ToggleSync
            integrationConfigured={props.integrationConfigured}
            syncEnabled={props.syncEnabled}
            action={props.action}
            toggleUrl={props.toggleUrl}
            model={props.model}
            modelName={$t('Tracking Categories')}
            syncNowUrl={props.syncNowUrl}
            toggleCallback={() => {
                props.toggleCallback();
            }}
            toggleModalId={'enable-tracking-categories-sync'}
            importNowMessage={$t('Import {{model}} now', { model: $t('Tracking Categories') })}
            hideDescription={true}
        />
    );
}
